import React, { useEffect, useRef } from "react";
import { Box, Typography, Paper } from "@mui/material";

const CashPayment = ({
  total,
  onPaymentDataChange,
  amountCash,
  setAmountCash,
  parametrage,
}) => {
  const isInitialized = useRef(false);

  useEffect(() => {
    // Auto-fill total on mount for speed, but only once to avoid loops
    if (
      amountCash === 0 &&
      !isInitialized.current &&
      total > 0 &&
      parametrage?.defaultCashInput
    ) {
      setAmountCash(total.toFixed(3));
      onPaymentDataChange({ amount: total, rendu: 0 }, "cash");
      isInitialized.current = true;
    }

    const handleVirtualInput = (e) => {
      if (e.detail.method === "cash" && e.detail.input === "amount") {
        const val = parseFloat(e.detail.value) || 0;
        setAmountCash(val);
        onPaymentDataChange(
          { amount: val, rendu: Math.max(0, val - total) },
          "cash",
        );
      }
    };

    window.addEventListener("virtualKeyboardInput", handleVirtualInput);
    return () =>
      window.removeEventListener("virtualKeyboardInput", handleVirtualInput);
  }, [total]); // Total as dependency only for the initial check

  const handlePhysicalKeyDown = (e) => {
    console.log("e.key", e.key);
    if (e.key === "Enter") return;
    let currentStr = amountCash.toString();
    if (e.key === "Backspace") currentStr = currentStr.slice(0, -1);
    else if (/[0-9.]/.test(e.key)) currentStr += e.key;

    const newVal = parseFloat(currentStr) || 0;
    console.log("newVal", newVal);
    setAmountCash(newVal);
    onPaymentDataChange(
      { amount: newVal, rendu: Math.max(0, newVal - total) },
      "cash",
    );
  };

  return (
    <Box sx={{ p: 1 }}>
      <Paper
        tabIndex={0}
        onKeyDown={handlePhysicalKeyDown}
        data-payment="cash" // Add this line
        onFocus={() =>
          window.dispatchEvent(
            new CustomEvent("virtualKeyboardFocus", {
              detail: { method: "cash", input: "amount" },
            }),
          )
        }
        sx={{
          p: 1,
          fontSize: "1rem",
          textAlign: "right",
          border: "2px solid #2e7d32",
          outline: "none",
          "&:focus": { bgcolor: "#f1f8e9" },
        }}
      >
        {amountCash || "0.000"} <small style={{ fontSize: "1rem" }}></small>
      </Paper>
    </Box>
  );
};

export default CashPayment;
